/*
 * PLATIN New Era single-unit offer: reflect variant base prices in the crossed-out
 * amount, without touching Shopify cart, variant data or the automatic discount.
 * Only the ILS market renders this sale price in Liquid.
 */
(function () {
  'use strict';

  function moneyILS(cents) {
    var amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '';
    return '\u20aa ' + amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function updatePrice(priceList, variant) {
    if (!priceList || !variant || !Number.isFinite(Number(variant.price))) return;

    var cents = Number(variant.price);
    var promoCents = Number(priceList.getAttribute('data-platin-promo-price'));
    if (!Number.isFinite(promoCents)) return;

    var sale = priceList.querySelector('[data-platin-new-era-promo-sale]');
    var regular = priceList.querySelector('[data-platin-new-era-promo-regular]');
    if (!sale || !regular) return;

    var showPromo = cents > promoCents;
    // Preserve the accessibility label; replace only the numeric amount.
    var saleLabel = sale.querySelector('.sr-only');
    sale.textContent = moneyILS(showPromo ? promoCents : cents);
    if (saleLabel) sale.prepend(saleLabel);
    var regularLabel = regular.querySelector('.sr-only');
    regular.textContent = moneyILS(cents);
    if (regularLabel) regular.prepend(regularLabel);
    regular.hidden = !showPromo;

    priceList.querySelectorAll('[data-platin-new-era-promo-note]').forEach(function (note) {
      note.hidden = !showPromo;
    });

    var linkedForm = priceList.getAttribute('data-platin-promo-form');
    if (linkedForm) {
      document.querySelectorAll('[data-platin-new-era-promo-note][data-platin-promo-form]').forEach(function (note) {
        if (note.getAttribute('data-platin-promo-form') === linkedForm) {
          note.hidden = !showPromo;
        }
      });
    }
  }

  document.addEventListener('variant:change', function (event) {
    if (!event.detail || !event.detail.variant) return;
    var formId = event.target && event.target.id;
    if (!formId) return;

    document.querySelectorAll('price-list[data-platin-new-era-promo-price-list]').forEach(function (priceList) {
      var linkedForm = priceList.getAttribute('data-platin-promo-form');
      // Mobile custom sticky bar has no direct form reference.
      var isSticky = !!priceList.closest('#sticky-atc-bar');
      if (linkedForm === formId || (isSticky && formId.indexOf('product-form-') === 0)) {
        updatePrice(priceList, event.detail.variant);
      }
    });
  }, false);
})();
